import find from 'lodash/find';

import firehydrantAPI from 'helpers/firehydrantAPI';
import { useApiQuery } from 'queries/common';

export const ENTITLEMENTS_LIST = ['entitlements', 'list'];

export const useEntitlement = (params = {}, enabled = true) => {
  const query = useApiQuery(
    ['entitlements', 'list', params],
    () => firehydrantAPI.get(`entitlements`, params),
    { enabled },
  );

  return {
    ...query,
    data: find(query?.data?.data?.data, { slug: params.params.name }) || {},
  };
};

export const useQuotas = (params) => {
  const requestParams = { params: { type: 'quota', ...params } };
  const query = useApiQuery(['entitlements', 'list', requestParams], () =>
    firehydrantAPI.get(`entitlements`, requestParams),
  );

  return {
    ...query,
    data: query?.data?.data?.data || {},
  };
};
